import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why bigger penis == bigger confidence [nsfw-ish]",
  "description": "",
  "published": "2010-01-20T00:00:00.000Z",
  "redirect_from": ["/blog/why-bigger-penis-bigger-confidence-nsfw-ish/swizec/1154"],
  "categories": "Adult, advice, Biology, Evolution, food for thought, Human, intrigues, Male, Species, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:2005_walking_penis.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/01/300px-2005_walking_penis.jpg",
              "alt": "Walking penis. Gay pride parade, 2005.",
              "title": "Walking penis. Gay pride parade, 2005."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:2005_walking_penis.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p><strong parentName="p">{`Size matters!`}</strong></p>
    <p>{`But obviously that's a very lame argument so let's work it out a bit.`}</p>
    <p>{`Everybody knows that when it comes to impregnating homo sapienatic females any and all but the weirdest of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Male",
        "title": "Male"
      }}>{`male`}</a>{` homo sapienatic instruments will do. It can be wide, it can be small, it can be whatever. As long as it's longer than 5 inches you're good and obviously since you're here and we have this thing called `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Evolution",
        "title": "Evolution"
      }}>{`evolution`}</a>{` and inherited traits, chances are your `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Phallus",
        "title": "Phallus"
      }}>{`phallic`}</a>{` instrument is longer than 5 inches mister.`}</p>
    <p>{`And 5 inches is quite alright, I wouldn't want a 5 inch knife in my back ...`}</p>
    <p>{`But homo sapiens are smart cookies and they needed something more out of sex. This thing called an endorphinal high, we like drugs maaan, because after all, if sex would hurt nobody would do it and then we'd all be fucked. Not to mention that's no fun at all.`}</p>
    <p>{`So most of the time when a homo sapiens female and a homo sapiens male get together it isn't to make little hobbits, it's to make fun and create natural occuring brain drugs. Woo.`}</p>
    <p>{`This however introduces a problem, the lukewarm hole most females sport is very stretchy and the more fun it's having the more it stretches. The damn thing does not in the least care about what you're putting inside, it just wants more and more and more and it gets bigger and bigger. Then the lady stops getting pleasure because she can't feel anything.`}</p>
    <p>{`Hell, there's very little friction left!`}</p>
    <p>{`What do? Well obviously you put a bigger instrument into the hands of the master male homo sapiens so that he could pleasure the female better. Problem solved!`}</p>
    <p>{`By the by, many animal `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Species",
        "title": "Species"
      }}>{`species`}</a>{` have tricks to make the female more ... uhm ... willing. Like cats have spikes on their instruments and ducks have a spiral penis! Wow, amazing, shocker!`}</p>
    <p>{`Ok so no bitching about "Size doesn't matter, it's how you use it" Sod off with those, size, in `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Human",
        "title": "Human"
      }}>{`humans`}</a>{`, is about 80% of the equation when it comes to pleasurable activities of the sort.`}</p>
    <p>{`Therein lies the problem. The more the woman wants to have fun, the bigger instrument she needs. But how can you tell who's got a big instrument when the damn bastards keep it neatly tucked away in their garment?`}</p>
    <p><strong parentName="p">{`Confidence!`}</strong></p>
    <p>{`The more confidence a male `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Sport",
        "title": "Sport"
      }}>{`sports`}</a>{` the bigger their schlong! The mechanism for how big schlong == big confidence is probably self-evident so let's leave it at this. The `}<em parentName="p">{`reason`}</em>{` why bigger schlong equals bigger confidence is that lasses need a heuristic for finding bigger pleasure.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/620b4d5a-69f5-487e-97eb-1b503a0ca9bf/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=620b4d5a-69f5-487e-97eb-1b503a0ca9bf",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      